import { Coffee, Soup, Cookie, Moon, UtensilsCrossed, type LucideIcon } from '../../ui/Icon';
import type { MealSlot, VenueCategory } from '../../../types';

/**
 * The look of each slot, in the order of the day. `OTHER` sits last because it
 * has no hour of its own — see MEAL_SLOTS in types.
 */
export const SLOT_META: Record<MealSlot, { Icon: LucideIcon; color: string; bg: string; accent: string }> = {
  BREAKFAST: { Icon: Coffee,          color: 'text-amber-600',  bg: 'bg-amber-50 dark:bg-amber-900/20',   accent: '#d97706' },
  LUNCH:     { Icon: Soup,            color: 'text-orange-600', bg: 'bg-orange-50 dark:bg-orange-900/20', accent: '#ea580c' },
  SNACK:     { Icon: Cookie,          color: 'text-rose-600',   bg: 'bg-rose-50 dark:bg-rose-900/20',     accent: '#e11d48' },
  DINNER:    { Icon: Moon,            color: 'text-indigo-600', bg: 'bg-indigo-50 dark:bg-indigo-900/20', accent: '#4f46e5' },
  OTHER:     { Icon: UtensilsCrossed, color: 'text-slate-500',  bg: 'bg-slate-100 dark:bg-slate-800',     accent: '#64748b' },
};

// ADR-0013: the place picker offers only where one eats; a cascade is noise there.
export const EATING_CATEGORIES: ReadonlySet<VenueCategory> = new Set(['RESTAURANT', 'CAFE']);

/** A place found from a breakfast or a snack is a café; any other meal, a restaurant. */
export function categoryForSlot(slot: MealSlot): VenueCategory {
  return slot === 'BREAKFAST' || slot === 'SNACK' ? 'CAFE' : 'RESTAURANT';
}
